import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AccountIdService } from '../account/account-id.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'not-found',
  styleUrls: ['./not-found.component.scss'],
  templateUrl: './not-found.component.html',
  providers: [AccountIdService],
})
export class NotFoundComponent {
  constructor(
    private readonly location: Location,
    readonly accountIdService: AccountIdService,
  ) {}

  back() {
    return this.location.back();
  }

  url() {
    return this.location.path(true);
  }
}
